class SkipLinks {
  constructor() {
    this.links = document.querySelectorAll(".skip-link")
    this.bindEvents()
  }

  bindEvents() {
    window.addEventListener(
      "hashchange",
      ev => {
        this.onHashChange(ev)
      },
      false
    )
  }

  onHashChange(ev) {
    const hash = ev.target.location.hash
    const el = document.querySelector(hash)

    if (el) {
      el.setAttribute("tabindex", "-1")
      el.focus()
    } else {
      if (hash === "#MainNavigation") {
        if (window.matchMedia("(min-width: 1200px)").matches) {
          const desktopNavigation = document.getElementById("desktop_navigation")

          desktopNavigation.setAttribute("tabindex", "-1")
          desktopNavigation.focus()
        } else {
          const mobileToggle = document.querySelector(".header .header__mobile-toggle")
          mobileToggle.focus()
        }
      }
    }
  }
}

export default function init() {
  if (document.querySelector(".skip-link")) {
    new SkipLinks()
  }
}
